import { __awaiter, __generator, __read } from "tslib";
import { APP_DEFINITION_ID, PageMap } from '@wix/wixstores-client-core';
export var getCheckoutUrl = function (_a) {
    var context = _a.context;
    return function (urlParams) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, url, relativeUrl, queryString;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, context.wixApi.site.getSectionUrl({
                        sectionId: PageMap.CHECKOUT,
                        appDefinitionId: APP_DEFINITION_ID,
                    })];
                case 1:
                    _a = _b.sent(), url = _a.url, relativeUrl = _a.relativeUrl;
                    queryString = Object.entries(urlParams)
                        .filter(function (_a) {
                        var _b = __read(_a, 2), _ = _b[0], value = _b[1];
                        return !!value;
                    })
                        .map(function (_a) {
                        var _b = __read(_a, 2), key = _b[0], value = _b[1];
                        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
                    })
                        .join('&');
                    return [2 /*return*/, {
                            url: "".concat(url, "?").concat(queryString),
                            relativeUrl: "".concat(relativeUrl, "?").concat(queryString),
                        }];
            }
        });
    }); };
};
//# sourceMappingURL=getCheckoutUrl.js.map